import React, { useState } from "react";
import { HiDotsHorizontal } from "react-icons/hi";
import ReactPaginate from "react-paginate";
import { Modal, Button, Table, Form } from "react-bootstrap";
import "../css/pagination.css";
import { CiEdit } from "react-icons/ci";
import { BsCardChecklist } from "react-icons/bs";
import { TfiStatsUp } from "react-icons/tfi";
import { MdOutlineDelete } from "react-icons/md";
import { FaCheckDouble } from "react-icons/fa6";
import axios from "axios";
import { confirmable } from "react-confirm";

const TableComp = ({ members, itemsPerPage, reloadTable }) => {
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  const handlePageClick = (event) => {
    const newPage = event.selected;
    setCurrentPage(newPage);
  };

  const offset = currentPage * itemsPerPage;
  const currentPageData = members.slice(offset, offset + itemsPerPage);

  const handleClose = () => setShow(false);
  const handleShow = (row) => {
    setSelectedRow(row);
    setShow(true);
  };
  const isCardDelivered = async (row) => {
    console.log(row);
    const shouldRemove = window.confirm(
      `Are you sure you card was deliver to ${row.name}?`
    );

    if (shouldRemove) {
      // Remove logic here
      try {
        const res = await axios.get(
          `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/update-card?id=${row.id}`
        );
        let retcode = res.data;
        console.log(retcode);
        //show toast
        setShow(!show);
      } catch (error) {
        //show toast
        setShow(!show);
        console.log("update card delivered error =>" + error);
      }
    }
  };
  const deleteRecord = async (row) => {
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/delete-member?uid=${row.id}`
      );
      let retcode = res.data;
      console.log(retcode);
      //show toast
      setShow(!show);
      reloadTable(reloadTable);
    } catch (error) {
      //show toast
      setShow(!show);
      console.log("delete member error =>" + error);
    }
  };
  const handleRowSelect = (row, isSelected) => {
    console.log(row, isSelected);
    if (isSelected) {
      setSelectedRows((prev) => [...prev, row]);
    } else {
      setSelectedRows((prev) =>
        prev.filter((selectedRow) => selectedRow.mnumber !== row.mnumber)
      );
    }
  };
  const handleDeleteSelected = () => {
    selectedRows.forEach(async (item) => {
      try {
        await deleteRecord(item); // Wait for the deletion process to complete for each item
      } catch (error) {
        console.log("Error deleting member:", error);
      }
    });
    reloadTable(reloadTable);
  };

  return (
    <div>
      {selectedRows.length === 0 ? null : (
        <Button
          className="bg-danger text-white mb-3"
          onClick={() => {
            const shouldRemove = window.confirm(
              `Are you sure you want to delete multiple records?`
            );

            if (shouldRemove) {
              handleDeleteSelected();
            }
          }}
        >
          Delete Selected
        </Button>
      )}

      <Table striped bordered hover className="shadow">
        <thead>
          <tr>
            <th>Check.</th>
            <th>Member No.</th>
            <th>Name</th>
            <th>Surname</th>
            <th>Cell</th>
            {/* <th>Card</th> */}
            <th>Category</th>
            <th>Card No</th>
            <th>Gender</th>
            <th>Reg Date</th>
            <th>Menu</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentPageData.map((row, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedRows.some(
                    (selectedRow) => selectedRow.id === row.id
                  )}
                  onChange={(e) => handleRowSelect(row, e.target.checked)}
                />
              </td>
              <td>
                <small>{row.mnumber}</small>
              </td>
              <td>
                <small>{row.name}</small>
              </td>
              <td>
                <small>{row.surname}</small>
              </td>
              <td>
                <small>{row.cell}</small>
              </td>
              {/* <td
                className={row.card === "Yes" ? "bg-success" : "bg-danger"}
              ></td> */}
              <td>
                <small>{row.type}</small>
              </td>
              <td>
                <small
                  className="badge"
                  style={{ background: "#3bc0c3", width: "100%" }}
                >
                  {row.tagid}
                </small>
              </td>
              <td>
                <small>{row.gender}</small>
              </td>
              <td>
                <small className="badg badge-warning">{row.date}</small>
              </td>
              <td>
                <Button
                  className="bg-body text-black border-0"
                  onClick={() => handleShow(row)}
                >
                  <HiDotsHorizontal />
                </Button>
              </td>
              <td>
                <Button
                  className="bg-danger text-white border-0"
                  onClick={() => {
                    const shouldRemove = window.confirm(
                      `Are you sure you want to delete Member ${row.mnumber}?`
                    );

                    if (shouldRemove) {
                      deleteRecord(row);
                      reloadTable(reloadTable);
                    }
                  }}
                >
                  <MdOutlineDelete size={20} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ReactPaginate
        previousLabel={"previous"}
        nextLabel={"next"}
        breakLabel={"..."}
        pageCount={Math.ceil(members.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Extra Menu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRow ? (
            <div className="row">
              <div className="col-md-8">
                <div className="row">
                  <Form>
                    <Form.Group className="mb-2" controlId="formBasicEmail">
                      <Form.Label>
                        <small>
                          <b>Number</b>
                        </small>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        disabled
                        placeholder="Enter number"
                        value={selectedRow.mnumber}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2" controlId="formBasicEmail">
                      <Form.Label>
                        <small>
                          <b>Name</b>
                        </small>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        disabled
                        placeholder="Enter nae"
                        value={selectedRow.name}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2" controlId="formBasicEmail">
                      <Form.Label>
                        <small>
                          <b>Surname</b>
                        </small>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        disabled
                        placeholder="Enter surname"
                        value={selectedRow.surname}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2" controlId="formBasicEmail">
                      <Form.Label>
                        <small>
                          <b>Cell</b>
                        </small>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        disabled
                        placeholder="Enter cell"
                        value={selectedRow.cell}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2" controlId="formBasicEmail">
                      <Form.Label>
                        <small>
                          <b>Email</b>
                        </small>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        disabled
                        placeholder="Enter email"
                        value={selectedRow.email}
                      />
                    </Form.Group>

                    <Button variant="primary" type="submit" disabled>
                      <FaCheckDouble className="me-2" />
                      Submit Update
                    </Button>
                  </Form>
                </div>
              </div>
              <div className="col-md-4">
                <small className="text-muted">actions</small>
                <hr className="mb-1" />
                <Button
                  className="mt-3 w-100"
                  variant="success"
                  type="submit"
                  disabled
                  style={{ height: 70 }}
                >
                  <CiEdit className="me-2" />
                  Enable Edit
                </Button>
                <Button
                  className="mt-3 w-100"
                  variant="info"
                  type="submit"
                  style={{ height: 70 }}
                  disabled={selectedRow.card == "Yes" ? true : false}
                  onClick={() => {
                    isCardDelivered(selectedRow);
                  }}
                >
                  <BsCardChecklist className="me-2" />
                  Card Printed ?
                </Button>
                <Button
                  className="mt-3 mb-2 w-100"
                  variant="warning"
                  type="submit"
                  disabled
                  style={{ height: 70 }}
                >
                  <TfiStatsUp className="me-2" />
                  Attandance Record
                </Button>
                <small className="text-muted">danger zone</small>x
              </div>
            </div>
          ) : (
            <p>No data available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default TableComp;
